module.exports = __webpack_public_path__ + "static/media/img-sobre.88768bda.webp";